"use strict";

exports.__esModule = true;
exports.default = isObjectURL;
/**
 * Check if a URL string is an object URL from `URL.createObjectURL`.
 */
function isObjectURL(url) {
  return url.startsWith('blob:');
}